import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/study/:id',
    name: 'StudyEntry',

    // "preferred view" customization temporary disabled (OAN-2552)
    // returns a redirect, so `component` is a fallback that is not expected to render.
    // component: () => import('../core/components/app-initial-loader/app-initial-loader.vue'),
    // beforeEnter: (to) => import('./route-entry').then((m) => m.resolveEntryRoute(to)),
    // ----------------------------------------------------------------------------------
    redirect: (to) => ({
      name: 'OverviewView',
      params: { id: to.params.id },
      query: to.query,
      hash: to.hash
    })
  },
  {
    path: '/study/:id/graphs/:epochSize/:epochSelected',
    name: 'EpochViewUnscored',
    component: () => import('../modules/epoch/feature')
  },
  {
    path: '/study/:id/graphs/:epochSize/:epochSelected/:scoreSet',
    name: 'EpochView',
    component: () => import('../modules/epoch/feature')
  },
  {
    path: '/study/:id/report',
    name: 'ReportViewBasic',
    component: () => import('../modules/report/feature')
  },
  {
    path: '/study/:id/report/',
    name: 'ReportView',
    component: () => import('../modules/report/feature')
  },
  {
    path: '/study/:id/report/print',
    name: 'PrintReportView',
    component: () => import('../modules/report/feature').then((m) => m.PrintView)
  },
  {
    path: '/study/:id/overview',
    name: 'OverviewView',
    component: () => import('../modules/overview/feature').then((m) => m.OverviewView)
  },
  // redirect to maintain compatibility with old Navigator.
  {
    path: '/report/:id',
    redirect: (to) => ({
      name: 'StudyEntry',
      params: { id: to.params.id },
      query: to.query,
      hash: to.hash
    })
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../modules/not-found/not-found.component.vue')
  }
];

export const router = createRouter({
  history: createWebHistory(),
  routes
});
